module.exports = __webpack_public_path__ + "static/media/perpustakaan.f7630c0c.png";